
import {takeUntil} from 'rxjs/operators';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { Subject } from 'rxjs';
import { LeukoplastService } from './Leukoplast.service';
import { ILeukoplastSegment } from '../../../model/product/tena/leukoplast/ILeukoplastSegment';
import { ILeukoplastWebShopCatalogApi } from '../../../model/product/tena/leukoplast/ILeukoplastWebShopCatalogApi';

@Component({
    selector: 'admin-leukoplast-country-segment-menu',
    templateUrl: 'LeukoplastCountrySegmentMenu.component.html'
})
export class LeukoplastCountrySegmentMenuComponent implements OnInit, OnDestroy {
    countryModalVisible: boolean;
    segmentModalVisible: boolean;
    country: ILeukoplastWebShopCatalogApi;
    segment: ILeukoplastSegment;

    @Input()
    useSegment = true;

    private unsubscribe: Subject<void> = new Subject();

    constructor(private leukoplastService: LeukoplastService) {}

    ngOnInit() {
        // First show country popup and then segment popup.
        this.initializeCountryModal();
    }

    initializeCountryModal(): void {
        this.leukoplastService.countryModalVisible.pipe(
            takeUntil(this.unsubscribe))
            .subscribe(visible => {
                this.countryModalVisible = visible;
            });

        this.leukoplastService.countryChanged.pipe(takeUntil(this.unsubscribe)).subscribe(country => {
            if (country) {
                this.country = country;

                if (this.useSegment) {
                    // Now show segment popup
                    this.initializeSegmentModal();
                }
            }
        });

        let sessionStorageCountry = this.leukoplastService.getActiveCountry();
        if (sessionStorageCountry) {
            this.leukoplastService.countryChanged.next(sessionStorageCountry);
            this.leukoplastService.countryModalVisible.next(false);
        } else {
            this.leukoplastService.countryModalVisible.next(true);
        }
    }

    initializeSegmentModal(): void {
        this.leukoplastService.segmentModalVisible.pipe(
            takeUntil(this.unsubscribe))
            .subscribe(visible => {
                this.segmentModalVisible = visible;
            });

        this.leukoplastService.segmentChanged.pipe(takeUntil(this.unsubscribe)).subscribe(segment => {
            if (segment) {
                this.segment = segment;
            }
        });

        let sessionStorageSegment = this.leukoplastService.getActiveSegment();
        if (sessionStorageSegment) {
            this.leukoplastService.segmentChanged.next(sessionStorageSegment);
            this.leukoplastService.segmentModalVisible.next(false);
        } else {
            this.leukoplastService.segmentModalVisible.next(true);
        }
    }

    selectSegment() {
        this.leukoplastService.segmentModalVisible.next(true);
    }

    selectCountry() {
        this.leukoplastService.countryModalVisible.next(true);
    }

    ngOnDestroy() {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }
}
